import { render, staticRenderFns } from "./DirectLinkModal.vue?vue&type=template&id=24cc6a49&"
import script from "./DirectLinkModal.vue?vue&type=script&lang=js&"
export * from "./DirectLinkModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports